// extracted by mini-css-extract-plugin
export default {"l_HistoryBackIcon_main":"HistoryBackIcon_l_HistoryBackIcon_main__f1V0b","l_HistoryBackIcon_iconImg":"HistoryBackIcon_l_HistoryBackIcon_iconImg__cBYPp"};